import { useCallback } from 'react';
import { useMediaUpload } from '@org/ui';
import type { MediaUploadResult } from '@org/ui';

export function useRichTextMediaUpload() {
  const { uploadMedia } = useMediaUpload();

  return useCallback(
    async (file: File): Promise<MediaUploadResult> => {
      const result = await uploadMedia(file);
      if (!result?.mediaUrl) throw new Error('Upload failed');
      const kind: 'image' | 'video' = file.type.startsWith('video/') ? 'video' : 'image';
      return { url: result.mediaUrl, kind };
    },
    [uploadMedia]
  );
}
